import React from 'react';

const LoadingState = ({ 
  message = "Loading...", 
  showSpinner = true, 
  size = "medium",
  className = "" 
}) => {
  const sizeClasses = {
    small: "ov-loading-small",
    medium: "ov-loading-medium", 
    large: "ov-loading-large"
  };

  return (
    <div className={`ov-loading-state ${sizeClasses[size]} ${className}`} role="status" aria-live="polite">
      {showSpinner && (
        <div className="ov-loading-spinner" aria-hidden="true">
          <div className="ov-spinner-ring"></div>
        </div>
      )}
      <div className="ov-loading-message">{message}</div>
    </div>
  );
};

// Skeleton loading component for cards
export const SkeletonCard = ({ lines = 3, className = "" }) => (
  <div className={`ov-skeleton-card ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <div 
        key={i} 
        className={`ov-loading-skeleton ${i === 0 ? 'ov-skeleton-title' : 'ov-skeleton-text'}`}
        style={{ width: i === 0 ? '80%' : i === lines - 1 ? '60%' : '100%' }}
      />
    ))}
  </div>
);

// Loading overlay for full-screen operations
export const LoadingOverlay = ({ message = "Processing...", show = false }) => {
  if (!show) return null;

  return (
    <div className="ov-loading-overlay" role="status" aria-live="polite">
      <div className="ov-loading-overlay-content">
        <div className="ov-loading-spinner ov-spinner-large" aria-hidden="true">
          <div className="ov-spinner-ring"></div>
        </div>
        <div className="ov-loading-message">{message}</div>
      </div>
    </div>
  );
};

// Inline loading indicator for buttons
export const InlineLoader = ({ size = "small" }) => (
  <div className={`ov-inline-loader ov-loader-${size}`} aria-hidden="true">
    <div className="ov-spinner-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
);

export default LoadingState;
